<script lang="ts" setup>
import type { MenuItem } from '@bloomreach/spa-sdk'
import { type PropType, computed } from 'vue'
import { useHeader } from '@/cms-ui/composables/useHeader'
import { useClickTracking } from '@/cms-ui/composables/useAnalytics'
import { EClickElement } from '@/cms-ui/utils/dataLayer'

const props = defineProps({
    item: {
        type: Object as PropType<MenuItem>,
        default: () => ({}),
    },
    index: {
        type: Number,
        default: null,
    },
})
const { mobileItemActiveIndex, getTarget } = useHeader()

const isOpen = computed(() => mobileItemActiveIndex.value === props.index)
const isButton = !props.item.getUrl()

function toggleAccordion(index: number, item: MenuItem): void {
    mobileItemActiveIndex.value = mobileItemActiveIndex.value === index ? null : index
    useClickTracking({
        label: item.getName(),
        clickPath: item.getUrl() || '',
        clickElement: EClickElement.TEXT,
        componentName: item.getName(),
        componentCategory: 'menu',
    })
}
</script>

<template>
    <div>
        <component
            :is="isButton ? 'button' : 'a'"
            :href="isButton ? null : item.getUrl()"
            :target="getTarget(item)"
            class="text-comp-high-contrast label-lg p-base flex w-full justify-between"
            @click="toggleAccordion(index, item)"
        >
            <slot />
            <VIcon
                v-if="isButton"
                name="chevron-down"
                size="MEDIUM"
                class="transition-transform"
                :class="{ 'rotate-180': isOpen }"
            />
        </component>
        <div
            v-if="isButton"
            id="mobile-menu"
            class="bg-neutral-primary-invert grid overflow-hidden transition-all lg:hidden"
            :class="
                isOpen
                    ? 'grid-rows-[1fr] opacity-100 duration-400 ease-in-out'
                    : 'grid-rows-[0fr] opacity-0 duration-400 ease-in-out'
            "
        >
            <div class="overflow-hidden">
                <div>
                    <a
                        v-for="el in item.getChildren()"
                        :key="el.getName()"
                        :href="el.getUrl()"
                        :target="getTarget(el)"
                        class="p-base label-lg text-neutral-primary-invert block"
                        @click="
                            useClickTracking({
                                label: el.getName(),
                                clickPath: el.getUrl() || '',
                                clickElement: EClickElement.LINK,
                                componentName: el.getName(),
                                componentCategory: 'menu',
                            })
                        "
                    >
                        {{ el.getName() }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>
